var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1641 7.49935C14.1641 10.7243 11.3641 13.3327 7.91406 13.3327L7.13907 14.266L6.68073 14.816C6.28907 15.2827 5.53906 15.1827 5.28073 14.6243L4.16406 12.166C2.6474 11.0993 1.66406 9.40768 1.66406 7.49935C1.66406 4.27435 4.46406 1.66602 7.91406 1.66602C10.4307 1.66602 12.6057 3.05769 13.5807 5.05769C13.9557 5.79936 14.1641 6.62435 14.1641 7.49935Z",
    stroke: "#30BEAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3323 10.7169C18.3323 12.6252 17.349 14.3169 15.8323 15.3836L14.7156 17.8419C14.4573 18.4002 13.7073 18.5086 13.3156 18.0336L12.0823 16.5502C10.0656 16.5502 8.26563 15.6586 7.14062 14.2669L7.91562 13.3336C11.3656 13.3336 14.1656 10.7253 14.1656 7.50025C14.1656 6.62525 13.9573 5.80026 13.5823 5.05859C16.3073 5.68359 18.3323 7.98358 18.3323 10.7169Z",
    stroke: "#30BEAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83594 7.5H10.0026",
    stroke: "#30BEAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.fed1759fbe7597dbbebfbd4b0f49d084.svg";
export { ForwardRef as ReactComponent };